import React from "react";
import { ReactComponent as CopyRightIcon } from "../../assets/images/dashboard/CopyRightIcon.svg";

const Footer = () => {
  return (
    <>
      <div className="site-footer flex gap-1 justify-center items-center w-full font-normal text-[14px] text-[#4B5563]">
        <p className="">{new Date().getFullYear()}</p>
        <CopyRightIcon className="mx-1" width={12} height={12} aria-label="copyright" />{" "}
        <p>BuildTrack All rights reserved</p>
      </div>
    </>
  );
};

export default Footer;
